// extracted by mini-css-extract-plugin
module.exports = {"heading":"audit_heading__3qqDv","prize":"audit_prize__2RFv6"};